import { Typography } from 'antd';
import React from 'react';

const Delete = () => {
  return (
    <Typography.Text type='danger' style={{ marginRight: '8px' }}>
      DELETE
    </Typography.Text>
  );
};

export default Delete;
